import React from 'react'

import { Avatar, AvatarImage } from '@/components/ui/avatar'
import type { FaceCheckOutputGroup } from '@/store/api/Workspace/Workspace.types'

interface FaceMatchAvatarsProps {
  items: FaceCheckOutputGroup[]
  overlap?: boolean
}

export const FaceMatchAvatars: React.FC<FaceMatchAvatarsProps> = ({
  items,
  overlap = true,
}) => {
  const avatars = items.flatMap((group) => group)
  return (
    <div className="flex flex-row items-center h-8">
      {avatars.map((avatar, index) => {
        const isLast = index === avatars.length - 1
        return (
          <div
            key={avatar.guid}
            className={
              overlap && !isLast ? 'px-2 -mr-[21px] shrink-0' : 'px-2 shrink-0'
            }
          >
            <Avatar className="w-8 h-8">
              <AvatarImage src={avatar.base64} />
            </Avatar>
          </div>
        )
      })}
    </div>
  )
}
